import { render, staticRenderFns } from "./LensCreativeTestsIcon.vue?vue&type=template&id=8188a048"
import script from "./LensCreativeTestsIcon.vue?vue&type=script&lang=js"
export * from "./LensCreativeTestsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports